import { EnhancedError, FetchConfig } from 'src/redux/apiTypes';
import { CommentForPicker } from './useCommentsForPicker';

interface CommentsForPickerMap {
  [ean: string]: CommentForPicker;
}

export async function requestGetCommentsForPicker(
  fetchConfig: FetchConfig,
): Promise<CommentForPicker[]> {
  const { xChain, xVersion, apiRoot } = fetchConfig;
  const url = `${apiRoot}/user/comments_for_picker`;

  const options: RequestInit = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'x-chain': xChain,
      'x-version': xVersion,
    },
  };

  const response = await fetch(url, options);

  if (!response.ok) {
    const error: EnhancedError = new Error('An error occurred while fetching the data.');

    error.data = await response.json();
    error.status = response.status;

    throw error;
  }

  return response.json();
}

export async function requestPostCommentsForPicker(
  comments: CommentForPicker[],
  fetchConfig: FetchConfig,
): Promise<Response> {
  const { xChain, xVersion, apiRoot } = fetchConfig;
  const url = `${apiRoot}/user/comments_for_picker`;

  const options: RequestInit = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'x-chain': xChain,
      'x-version': xVersion,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(comments),
  };

  try {
    return await fetch(url, options);
  } catch (_error) {
    return {} as Response;
  }
}

export async function requestPutCommentsForPicker(
  editedComment: CommentForPicker,
  fetchConfig: FetchConfig,
): Promise<Response> {
  const { xChain, xVersion, apiRoot } = fetchConfig;
  const url = `${apiRoot}/user/comments_for_picker`;

  const options: RequestInit = {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'x-chain': xChain,
      'x-version': xVersion,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(editedComment),
  };

  try {
    return await fetch(url, options);
  } catch (_error) {
    return {} as Response;
  }
}

export async function requestDeleteCommentsForPicker(
  ean: string,
  fetchConfig: FetchConfig,
): Promise<Response> {
  const { xChain, xVersion, apiRoot } = fetchConfig;
  const url = `${apiRoot}/user/comments_for_picker`;

  const options: RequestInit = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'x-chain': xChain,
      'x-version': xVersion,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ean }),
  };

  try {
    return await fetch(url, options);
  } catch (_error) {
    return {} as Response;
  }
}


export function getEditedComments(commentsData: CommentForPicker[], editedComment: CommentForPicker): CommentForPicker[] {
  return commentsData.map((data) => {
    if (data.ean === editedComment.ean) {
      return editedComment;
    }

    return data;
  });
}

export function getCommentsMap(data: CommentForPicker[]): CommentsForPickerMap {
  return data.reduce((map: CommentsForPickerMap, comment) => {
    map[comment.ean] = comment;
    return map;
  }, {});
}
